module.exports = __webpack_public_path__ + "img/tianjiashouhuquyu.6287ba3c.png";